module.exports = __webpack_public_path__ + "static/img/door_success.2dc6b723.png";